import { useFeatureFlagEnabled } from '@posthog/react'

function analyticsConfigured() {
  return Boolean(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN?.trim())
}

function noFlag(): boolean | undefined {
  return undefined
}

/**
 * A PostHog feature flag: undefined until PostHog has loaded flags, and always
 * without a PostHog project, so callers treat anything but true as off.
 */
export function useProductFlag(key: string): boolean | undefined {
  // Without a PostHog project the provider is absent (see ProductAnalytics); the
  // configuration is fixed for the page's lifetime, so the hook order is stable.
  const useFlag = analyticsConfigured() ? useFeatureFlagEnabled : noFlag
  return useFlag(key)
}
